import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useParlamentarianSearchDispatch, useParlamentarianSearchState } from './parlamentarian-search-context';

export const useParlamentarianSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useParlamentarianSearchDispatch();
    const state = useParlamentarianSearchState();

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-name') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { name: value || undefined } });
        } else if (name === 'select-type') {
            dispatch({ type: ACTION_TYPES.updateParameter, payload: { type: value !== '' ? Number(value) : undefined } });
        }
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0 } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0, pageSize: 100, name: undefined, type: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() {
        navigate('/parlamentares/cadastrar');
    }

    function navigateToEdit(id: number) {
        navigate(`/parlamentares/editar/${id}`);
    }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToCreate, navigateToEdit };
};
